// @flow

import * as React from 'react';

import { selectCartIsWorking } from '@gandi/cart';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectCurrentBU } from 'src/modules/organization/selectors';

import Price from './Price';

type Props = {
  hasTaxes?: boolean,
  totalPrice: ?number,
  priceCrossedOut?: number,
  hasDiscount?: boolean,
};

export default function TotalRow({
  totalPrice,
  priceCrossedOut,
  hasTaxes,
  hasDiscount,
}: Props): React.MixedElement {
  const currentBU = useAppSelector(selectCurrentBU);
  const cartIsWorking = useAppSelector(selectCartIsWorking);

  return (
    <Base flex flexAlignItemsBaseline flexAlignSelfEnd>
      <Price
        price={cartIsWorking ? undefined : totalPrice}
        hasDiscount={hasDiscount}
        showExcludeVatMention={hasTaxes && currentBU !== 3}
        priceCrossedOut={priceCrossedOut}
      />
    </Base>
  );
}
